{
  "mainMenu": "Menu principal",
  "planned": "Cette page arrive bientôt.",
  "groups": {
    "messaging": "Messagerie",
    "gateway": "Passerelle",
    "billing": "Facturation",
    "administration": "Administration",
    "money": "Finances",
    "operations": "Exploitation"
  },
  "entries": {
    "overview": "Vue d’ensemble",
    "send": "Envoyer",
    "bulkSend": "Envoi groupé",
    "messages": "Messages",
    "devices": "Appareils",
    "apiKeys": "Clés d’API",
    "webhooks": "Webhooks",
    "apiGuide": "Guide de l’API",
    "wallet": "Portefeuille",
    "topUp": "Recharger",
    "plans": "Forfaits",
    "invoices": "Factures",
    "refunds": "Remboursements",
    "adminOverview": "Vue d’ensemble admin",
    "users": "Utilisateurs",
    "roles": "Rôles",
    "allDevices": "Tous les appareils",
    "allMessages": "Tous les messages",
    "webhookDeliveries": "Livraisons de webhooks",
    "planEditor": "Limites des forfaits",
    "payments": "Paiements",
    "reviewQueue": "À vérifier",
    "transfers": "Virements",
    "adminRefunds": "Remboursements",
    "reconciliation": "Rapprochement",
    "prices": "Tarifs",
    "reports": "Rapports",
    "jobs": "Tâches",
    "status": "État du système",
    "audit": "Journal d’audit",
    "settings": "Paramètres",
    "pages": "Pages"
  },
  "titles": {
    "batch": "Lot",
    "device": "Appareil",
    "webhook": "Webhook",
    "topup": "Recharge",
    "user": "Utilisateur",
    "role": "Rôle",
    "payment": "Paiement",
    "transfer": "Virement",
    "refund": "Remboursement",
    "job": "Tâche",
    "setting": "Paramètre",
    "page": "Page"
  },
  "account": {
    "menu": "Compte",
    "profile": "Profil",
    "security": "Sécurité",
    "sessions": "Sessions",
    "notifications": "Préférences d’e-mail",
    "support": "Assistance",
    "delete": "Supprimer le compte",
    "signOut": "Se déconnecter"
  },
  "palette": {
    "title": "Recherche",
    "trigger": "Rechercher…",
    "placeholder": "Rechercher des pages, appareils, messages…",
    "goTo": "Aller à",
    "recent": "Récents",
    "devices": "Appareils",
    "messages": "Messages",
    "users": "Utilisateurs",
    "noResults": "Aucun résultat",
    "searching": "Recherche…"
  },
  "alerts": {
    "label_one": "Alertes, {{count}} élément",
    "label_other": "Alertes, {{count}} éléments",
    "none": "Rien ne demande votre attention",
    "failedMessages": "Messages en échec (24 h)",
    "offlineDevices": "Appareils hors ligne",
    "transfersToReview": "Virements à vérifier",
    "openRefunds": "Remboursements ouverts",
    "paymentsToReview": "Paiements à vérifier",
    "failedJobs": "Tâches en échec"
  },
  "shortcuts": {
    "title": "Raccourcis clavier",
    "openPalette": "Ouvrir la recherche",
    "openReference": "Afficher cette liste",
    "goTo": {
      "overview": "Aller à la vue d’ensemble",
      "messages": "Aller aux messages",
      "send": "Aller à l’envoi",
      "devices": "Aller aux appareils",
      "wallet": "Aller au portefeuille",
      "transfers": "Aller aux virements",
      "users": "Aller aux utilisateurs"
    },
    "then": "puis"
  }
}
